import { PropsWithChildren } from "react";
import {
  halfWidthColumn,
  mainColumn,
  sideColumn,
  twoColumnsContainer,
} from "./styles.css";

const TwoColumns = ({ children }: PropsWithChildren) => {
  return <div className={twoColumnsContainer}>{children}</div>;
};

const MainColumn = ({ children }: PropsWithChildren) => {
  return <div className={mainColumn}>{children}</div>;
};

const SideColumn = ({ children }: PropsWithChildren) => {
  return <div className={sideColumn}>{children}</div>;
};

const HalfWidthColumn = ({ children }: PropsWithChildren) => {
  return <div className={halfWidthColumn}>{children}</div>;
};

TwoColumns.MainColumn = MainColumn;
TwoColumns.SideColumn = SideColumn;
TwoColumns.HalfWidthColumn = HalfWidthColumn;

export { TwoColumns };
